var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-meta-insights-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper d-none" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("channelName"),
                    help: _vm.getErrorMessage("channelName"),
                  },
                },
                [
                  _c("a-input", {
                    ref: "channelName",
                    attrs: {
                      placeholder: _vm.$t("whatsappChannel.channelName"),
                      name: "channelName",
                    },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.step === "oauth"
            ? _c("div", { staticClass: "connect-body" }, [
                _c("div", { staticClass: "requirements" }, [
                  _c("div", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("message.ensureFacebookAccount"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("message.ensureAdAccount"))),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("metaInsights.requireAdsReadScope"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("metaInsights.connectDescription"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("a-checkbox", {
                      attrs: { checked: _vm.termOfService },
                      on: {
                        change: function ($event) {
                          return _vm.acceptTermOfService("pp")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("search.integration.readAndAgree")) +
                          "\n                        "
                      ),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.acceptTermOfService("pp")
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("search.integration.privatePolicy"))
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.and")) +
                          "\n                        "
                      ),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.acceptTermOfService("tac")
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("search.integration.termsAndCondition")
                            )
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ])
            : _vm.step === "select-business"
            ? _c(
                "div",
                { staticClass: "select-business-body" },
                [
                  _c(
                    "a-spin",
                    { attrs: { spinning: _vm.loadingBusinesses } },
                    [
                      _c("BusinessList", {
                        attrs: {
                          businesses: _vm.businesses,
                          "show-personal": true,
                        },
                        model: {
                          value: _vm.selectedBusiness,
                          callback: function ($$v) {
                            _vm.selectedBusiness = $$v
                          },
                          expression: "selectedBusiness",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.step === "select-account"
            ? _c(
                "div",
                { staticClass: "select-account-body" },
                [
                  _vm.selectedBusiness
                    ? _c("div", { staticClass: "step-back" }, [
                        _c("a", { on: { click: _vm.goBackToBusinesses } }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("arrow_back"),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("metaInsights.changeBusiness")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "muted" }, [
                          _vm._v(_vm._s(_vm.selectedBusiness.name)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-spin",
                    { attrs: { spinning: _vm.loadingAccounts } },
                    [
                      _c("AdAccountList", {
                        attrs: { accounts: _vm.adAccounts },
                        model: {
                          value: _vm.selectedAdAccount,
                          callback: function ($$v) {
                            _vm.selectedAdAccount = $$v
                          },
                          expression: "selectedAdAccount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.handleCancel } },
              [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
            ),
            _vm._v(" "),
            _vm.step === "oauth"
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: "",
                      disabled: !_vm.termOfService || _vm.loading,
                    },
                    on: { click: _vm.handleSubmit },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("metaInsights.connectToMetaInsights")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.step === "select-business"
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: "",
                      disabled: !_vm.selectedBusiness || _vm.loadingAccounts,
                    },
                    on: { click: _vm.handleSelectBusiness },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("metaInsights.continue")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.step === "select-account"
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      primary: "",
                      disabled: !_vm.selectedAdAccount || _vm.creating,
                    },
                    on: { click: _vm.handleCreate },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("metaInsights.createChannel")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.termOfServiceModal
        ? _c("TermOfService", {
            attrs: { type: _vm.termOfServiceModal },
            on: {
              agree: _vm.acceptedTermOfService,
              cancel: function ($event) {
                _vm.termOfServiceModal = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }